export default __webpack_public_path__ + "static/media/food-delivery.85127473.png";